var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 8.49993C17.8333 7.9028 17.6055 7.30568 17.1499 6.85008C16.6943 6.39447 16.0972 6.16667 15.5 6.16667M15.5 15.5C19.366 15.5 22.5 12.366 22.5 8.5C22.5 4.63401 19.366 1.5 15.5 1.5C11.634 1.5 8.5 4.63401 8.5 8.5C8.5 8.81929 8.52138 9.13359 8.56278 9.44154C8.63087 9.94804 8.66492 10.2013 8.642 10.3615C8.61813 10.5284 8.58773 10.6184 8.50547 10.7655C8.4265 10.9068 8.28733 11.046 8.00899 11.3243L2.04673 17.2866C1.84496 17.4884 1.74407 17.5893 1.67192 17.707C1.60795 17.8114 1.56081 17.9252 1.53224 18.0442C1.5 18.1785 1.5 18.3212 1.5 18.6065V20.6333C1.5 21.2867 1.5 21.6134 1.62716 21.863C1.73901 22.0825 1.91749 22.261 2.13701 22.3728C2.38657 22.5 2.71327 22.5 3.36667 22.5H6.16667V20.1667H8.5V17.8333H10.8333L12.6757 15.991C12.954 15.7127 13.0932 15.5735 13.2345 15.4945C13.3816 15.4123 13.4716 15.3819 13.6385 15.358C13.7987 15.3351 14.052 15.3691 14.5585 15.4372C14.8664 15.4786 15.1807 15.5 15.5 15.5Z",
    stroke: "#3567D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/keyIcon.778b24301d79d74a6331aa10a0852b98.svg";
export { ForwardRef as ReactComponent };